import {
  Box,
  List,
  ListItem,
  Popover,
  PopoverProps,
  Typography,
} from "@mui/material";
import { useAppContext } from "../context/AppContext";
import { useMemo } from "react";
import { HorizontalStack } from "./primitives/Stacks";

export const TimelinePopover: React.FC<Omit<PopoverProps, "open">> = ({
  ...popoverProps
}) => {
  const { legend, timelinePopover, toggleTimelinePopover } = useAppContext();

  const displayValues = useMemo(() => {
    if (!timelinePopover?.marks) return null;
    return (
      <List dense>
        {timelinePopover.marks.map((mark) => {
          const isHidden = legend?.hidden?.includes(mark.id);
          if (isHidden) return;

          return (
            <ListItem key={mark.name}>
              <HorizontalStack alignItems="center" sx={{ width: "100%" }}>
                <Box
                  sx={{
                    background: mark.color,
                    borderRadius: 4,
                    height: 8,
                    width: 8,
                  }}
                />
                <Typography
                  color="text.secondary"
                  sx={{ flexGrow: 1 }}
                  variant="body2"
                >
                  {mark.name}:
                </Typography>
                <Typography
                  align="right"
                  color="text.primary"
                  flexGrow={1}
                  variant="body2"
                >
                  {mark.value}
                </Typography>
              </HorizontalStack>
            </ListItem>
          );
        })}
      </List>
    );
  }, [timelinePopover]);

  return (
    <Popover
      anchorEl={timelinePopover?.anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      disableRestoreFocus
      hideBackdrop
      onClose={() =>
        toggleTimelinePopover({ anchorEl: null, enforceOpen: false })
      }
      open={timelinePopover?.enforceOpen || Boolean(timelinePopover?.anchorEl)}
      slotProps={{ paper: { sx: { mt: 1, userSelect: "none" } } }}
      sx={!timelinePopover?.enforceOpen ? { pointerEvents: "none" } : {}}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      {...popoverProps}
    >
      {displayValues}
    </Popover>
  );
};

export default TimelinePopover;
